import "./Navbar.css";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  AppBar,
  Avatar,
  Box,
  FormControl,
  Grid2,
  InputLabel,
  Select,
  MenuItem as MuiMenuItem,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  Skeleton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/logos/admin_logo.svg";
import { getDynamicMenuData } from "../../services/general";
import { notifyError } from "../../utilities/helper";
import { MenuContext } from "../../App";
import { BeatLoader } from "react-spinners";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import InputAdornment from "@mui/material/InputAdornment";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
};

const Navbar = () => {
  const [selectedMenu, setSelectedMenu] = useState("");
  const [openSelects, setOpenSelects] = useState({});
  const [menuData, setMenuData] = useState(null);
  const [filterMenuData, setFilterMenuData] = useState([]);
  const [updatedMenuData, setUpdatedMenuData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [load, setLoad] = useState(false);
  const [fetchMenuData, setFetchMenuData] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [showCurrPassword, setShowCurrPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const toggleVisibility = (field) => {
    if (field === "curr") setShowCurrPassword(!showCurrPassword);
    if (field === "new") setShowNewPassword(!showNewPassword);
    if (field === "confirm") setShowConfirmPassword(!showConfirmPassword);
  };

  const access_token = localStorage.getItem("access_token");

  const { setSystemActions } = useContext(MenuContext);

  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleModalOpen = () => setOpenModal(true);
  const handleModalClose = () => setOpenModal(false);

  const selectRef = useRef(null);
  const location = useLocation();

  const roleId = localStorage.getItem("roleId");
  const role = localStorage.getItem("role");

  const renderTextOrSkeleton = (text) =>
    text ? text : <Skeleton width={50} height={"28px"} />;

  useEffect(() => {
    if (roleId && access_token && fetchMenuData) {
      getMenuData();

      setTimeout(() => {
        setFetchMenuData(false);
      }, 200);
    }
  }, [fetchMenuData]);

  const changePassSchema = yup.object().shape({
    currPassword: yup.string().required("Current Password is required"),
    newPassword: yup
      .string()
      .required("New Password is required")
      .min(8, "Password should be at least 8 characters long")
      .matches(/[A-Z]/, "Password should contain at least one uppercase letter")
      .matches(/[a-z]/, "Password should contain at least one lowercase letter")
      .matches(/[0-9]/, "Password should contain at least one number")
      .matches(
        /[@$!%*?&#]/,
        "Password should contain at least one special character",
      )
      .notOneOf(
        [yup.ref("currPassword"), null],
        "New Password should not be the same as the Current Password",
      ),
    confirmPassword: yup.string().required("Confirm Passoword is required"),
  });

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(changePassSchema),
    mode: "onChange",
    defaultValues: {
      currPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
  });

  const values = watch();

  const navbarLinks = useMemo(
    () => [
      {
        text: "At a Glance",
        link: "/Dashboard",
        isPermanent: false,
        dataId: "CanViewDashboard",
      },
      {
        text: "Patient",
        link: "/subject",
        dataId: "CanSeePatientList",
        isPermanent: false,
        dynamicText: renderTextOrSkeleton(menuData?.singlePatientAlias) || "",
      },
      {
        text: "Sites",
        link: "/site-management",
        dataId: "CanViewSiteManagement",
        isPermanent: false,
        dynamicText: renderTextOrSkeleton(menuData?.pluralSiteAlias) || "",
      },
      {
        text: "Drug Supply",
        dropdown: true,
        items: [
          {
            text: "Drug Shipment Management",
            link: "/drug-shipment-management",
            isPermanent: true,
            dynamicText:
              `Drug ${menuData?.singleShipmentAlias} Management` || "",
          },
          {
            text: "Depot Management",
            link: "/depot-management",
            dataId: "CanSeeDepotList",
            isPermanent: false,
            dynamicText: `${menuData?.singleDepotAlias} Management` || "",
          },
          {
            text: "Lots Management",
            link: "/lots-management",
            dataId: "CanSeeLotList",
            isPermanent: false,
            dynamicText: `${menuData?.singleLotAlias} Management` || "",
          },
          {
            text: "Label Group Management",
            link: "/label-group-management",
            dataId: "CanSeeLabelGroupsList",
            isPermanent: false,
          },
          {
            text: "Drug Type Management",
            link: "/drug-type-management",
            dataId: "CanSeeDrugTypeList",
            isPermanent: false,
          },
          {
            text: "Material List Approval",
            link: "/material-list-approval",
            isPermanent: true,
          },
          {
            text: "Drug Assignment-Batch Release",
            link: "/drug-assignment-batch-release",
            isPermanent: true,
          },
          {
            text: "Batch Release Approval",
            link: "/batch-release-approval",
            isPermanent: true,
          },
          {
            text: "Resupply Settings",
            link: "/resupply-settings",
            dataId: "CanViewResupplySettings",
            isPermanent: false,
          },
          {
            text: "Dose Level Management",
            link: "/dose-level-management",
            dataId: "CanViewDosageLevel",
            isPermanent: false,
          },
          {
            text: "Dispensation Management",
            link: "/dispensation-management",
            dataId: "CanViewDispensationList",
            isPermanent: false,
          },
          {
            text: "Pill Count Management",
            link: "/pill-count-management",
            dataId: "CanViewPillCount",
            isPermanent: false,
          },
        ],
      },
      {
        text: "Manage Study",
        dropdown: true,
        items: [
          { text: "Study caps", link: "/study-caps", isPermanent: true },
          {
            text: "Data corrections",
            link: "/data-corrections",
            isPermanent: true,
          },
          {
            text: "Cohort Management",
            link: "/cohort-management",
            dataId: "CanViewCohortManagement",
            isPermanent: false,
          },
          {
            text: "Data Export",
            link: "/Export",
            dataId: "CanViewExport",
            isPermanent: false,
          },
          // { text: "Reviewer Assignment", link: "/PatientVisits/AssociateCompletedVisits" },
          {
            text: "Enrollment List Approval",
            link: "/RandomizationApproval",
            dataId: "CanViewRandList",
            isPermanent: false,
            dynamicText: `${menuData?.enrollmentAlias} List Approval` || "",
          },
          {
            text: "Review Visits",
            link: "/PatientVisits/ReviewerLandingPage",
            dataId: "CanSeePatientVisitList",
            isPermanent: false,
            dynamicText: `Review ${menuData?.pluralVisitAlias}` || "",
          },
          {
            text: "Site Language Management",
            link: "/Site/SiteLanguagesManagement",
            isPermanent: true,
            dynamicText:
              `${menuData?.singleSiteAlias} Language Management` || "",
          },
          {
            text: "Import Sites",
            link: "/Site/Import",
            dataId: "CanImportSites",
            isPermanent: false,
            dynamicText: `Import ${menuData?.pluralSiteAlias}` || "",
          },
          {
            text: "Upload Reference Material",
            link: "/ReferenceMaterial/Upload",
            dataId: "CanUploadReferenceMaterials",
            isPermanent: false,
          },
          {
            text: "Role Management",
            link: "/role-management",
            dataId: "CanViewRolesList",
            isPermanent: false,
          },
          {
            text: "View Emails",
            link: "/Confirmation/ShowSavedConfirmations",
            dataId: "CanViewConfirmationList",
            isPermanent: false,
          },
          {
            text: "Site Association",
            link: "/SiteAssociation",
            isPermanent: true,
            dynamicText: `${menuData?.singleSiteAlias} Association` || "",
          },
        ],
      },
      {
        text: "Analytics",
        link: "/Analytics",
        dataId: "CanViewAnalyticsReportList",
        isPermanent: false,
      },
      {
        text: "Reference Materials",
        link: "/ReferenceMaterial",
        dataId: "CanViewReferenceMatieralList",
        isPermanent: false,
      },
    ],
    [menuData],
  );

  const handleToggle = (id) => {
    setOpenSelects((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  useEffect(() => {
    if (menuData && navbarLinks) {
      if (role == "Admin") {
        const updatedNavbarLinks = navbarLinks.map((link) => {
          if (link.dropdown) {
            return {
              ...link,
              items: link.items.map((item) => ({
                ...item,
                isPermanent: true,
              })),
            };
          } else {
            return {
              ...link,
              isPermanent: true,
            };
          }
        });
        setUpdatedMenuData(updatedNavbarLinks);
      } else {
        if (menuData?.hasActiveRoles === false) {
          const updatedNavbarLinks = [
            {
              text: "Sites",
              link: "/Site",
              dataId: "CanViewSiteManagement",
              isPermanent: true,
              dynamicText:
                renderTextOrSkeleton(menuData?.pluralSiteAlias) || "",
            },
            {
              text: "Manage Study",
              dropdown: true,
              items: [
                {
                  text: "Depot Management",
                  link: "/depot-management",
                  dataId: "CanSeeDepotList",
                  isPermanent: true,
                  dynamicText: `${menuData?.singleDepotAlias} Management` || "",
                },
              ],
            },
          ];
          setUpdatedMenuData(updatedNavbarLinks);
        } else if (menuData?.hasActiveRoles && filterMenuData?.length > 0) {
          const updatedNavbarLinks = navbarLinks.map((link) => {
            if (link.dropdown) {
              return {
                ...link,
                items: link.items.map((item) => ({
                  ...item,
                  isPermanent:
                    item.isPermanent ||
                    filterMenuData.some((menu) => menu.name === item.dataId),
                })),
              };
            } else {
              return {
                ...link,
                isPermanent:
                  link.isPermanent ||
                  filterMenuData.some((menu) => menu.name === link.dataId),
              };
            }
          });
          setUpdatedMenuData(updatedNavbarLinks);
        }
      }
    }
  }, [role, menuData, navbarLinks, filterMenuData]);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("token");
    localStorage.removeItem("roleId");
    localStorage.removeItem("role");
    localStorage.removeItem("studyName");

    window.location.href = "https://genesis.augursapps.com/?fromStudy=true";
  };

  const getMenuData = async () => {
    setLoad(true);
    try {
      const response = await getDynamicMenuData(roleId, access_token);
      if (response?.status == 200) {
        if (response.data?.result) {
          setLoad(false);
          setMenuData(response.data?.result);
          localStorage.setItem(
            "email",
            response.data?.result?.currentUser?.email,
          );
          localStorage.setItem(
            "pluralKitAlias",
            response.data?.result?.pluralKitAlias,
          );
          localStorage.setItem(
            "enrollmentAlias",
            response.data?.result?.enrollmentAlias,
          );
          localStorage.setItem(
            "globalDateFormat",
            response.data?.result?.globalDateFormat,
          );
          localStorage.setItem(
            "singlePatientAlias",
            response?.data?.result?.singlePatientAlias,
          );
          localStorage.setItem("studyType", response.data?.result?.studyType);
          localStorage.setItem("studyId", response.data?.result?.studyId);
          localStorage.setItem(
            "currentUserCultureCode",
            response.data?.result?.currentUser?.cultureCode,
          );
          setFilterMenuData(response?.data?.result?.associatedSystemActions);
          setSystemActions(response?.data?.result?.associatedSystemActions);
        } else {
          notifyError("Error in fetching menu data");
        }
      }
    } catch (err) {
      setLoad(false);
      notifyError("Error in fetching menu data");
      if (err.status === 401) {
        navigate("/unauthorize");
      } else if (
        err?.code === "ERR_NETWORK" &&
        err?.message === "Network Error"
      ) {
        navigate("/siteNotFound");
      }
    }
  };

  const isChangePasswordDisabled = (values) => {
    const { currPassword, newPassword, confirmPassword } = values;

    if (
      !currPassword ||
      !newPassword ||
      !confirmPassword ||
      newPassword !== confirmPassword
    ) {
      return true;
    }

    const minLength = newPassword.length >= 8;
    const hasUppercase = /[A-Z]/.test(newPassword);
    const hasLowercase = /[a-z]/.test(newPassword);
    const hasNumber = /[0-9]/.test(newPassword);
    const hasSpecialChar = /[@$!%*?&#]/.test(newPassword);
    const isDifferentFromCurrent = newPassword !== currPassword;

    return !(
      minLength &&
      hasUppercase &&
      hasLowercase &&
      hasNumber &&
      hasSpecialChar &&
      isDifferentFromCurrent
    );
  };

  const updatePassword = async (data) => {};

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        sx={{
          backgroundColor: "#3E4CF4",
          color: "black",
          boxShadow: "none",
          width: "100%",
          padding: "0 20px", // Optional padding for spacing
        }}
      >
        <Grid2
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "100%", margin: "0 auto" }}
        >
          <Grid2
            size={{ xl: 2, xs: 12, sm: 12, md: 2, lg: 1 }}
            className="flexCenterAlign"
          >
            <Link to="/">
              <img
                className="admin-logo"
                src={logo}
                alt="Genesis Logo"
                style={{ height: "30px" }}
              />
            </Link>
          </Grid2>

          <Grid2
            size={{ xl: 8, lg: 8, md: 8, sm: 12, xs: 12 }}
            className="flexCenterAlign"
          >
            <div className="nav-bar-container">
              {load ? (
                <div className="nav-bar-container">
                  {Array.from(
                    { length: role === "Admin" ? 7 : 4 },
                    (_, index) => (
                      <Skeleton key={index} width={100} height={38} />
                    ),
                  )}
                </div>
              ) : (
                <>
                  {updatedMenuData &&
                    updatedMenuData.map((link, index) =>
                      link.dropdown ? (
                        <FormControl
                          key={index}
                          variant="outlined"
                          className={`${
                            link?.text?.toLocaleLowerCase()?.includes("drug")
                              ? "med-width"
                              : "large-width"
                          }`}
                        >
                          <InputLabel
                            shrink={false}
                            sx={{
                              color: "white",
                              "&.Mui-focused": {
                                color: "#FFFFFF !important",
                              },
                              fontSize: "16px",
                              fontWeight: "100",
                            }}
                          >
                            {link.dynamicText ? link.dynamicText : link.text}
                          </InputLabel>
                          <Select
                            ref={selectRef}
                            open={!!openSelects[index]}
                            onOpen={() => {
                              setOpenSelects((prev) => ({
                                ...prev,
                                [index]: true,
                              }));
                              if (role !== "Admin") {
                                setFetchMenuData(true);
                              }
                            }}
                            onClose={() =>
                              setOpenSelects((prev) => ({
                                ...prev,
                                [index]: false,
                              }))
                            }
                            IconComponent={() => (
                              <ArrowDropDownIcon
                                sx={{ color: "white", cursor: "pointer" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleToggle(index);
                                }}
                              />
                            )}
                            MenuProps={{
                              className: "custom-menu-root",
                            }}
                            sx={{
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                              "& .Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: "none",
                                },
                              "& .MuiMenuItem-root:hover": {
                                backgroundColor: "transparent",
                              },
                            }}
                            value={selectedMenu}
                            onChange={() => {}}
                            label={link.dynamicText}
                          >
                            {link.items
                              .filter((item) => item.isPermanent) // Filter dropdown items only
                              .map((item, idx) => (
                                <MuiMenuItem
                                  onClick={() => {
                                    if (role !== "Admin") {
                                      setFetchMenuData(true);
                                    }
                                  }}
                                  sx={{
                                    "&:focus": {
                                      outline: "none",
                                      backgroundColor: "transparent",
                                      color: "#161616",
                                      textDecoration: "none",
                                    },
                                    "&:hover": {
                                      background: "#f9f9f9",
                                      color: "#3661EB",
                                    },
                                    margin: "0px",
                                    padding: "0px 5px",
                                    color: "#161616",
                                  }}
                                  key={idx}
                                  value={item.link}
                                  component={Link}
                                  to={item.link}
                                >
                                  <h6
                                    style={{
                                      margin: "auto 0px",
                                      padding: "10px",
                                    }}
                                    className={`${
                                      item?.text
                                        ?.toLocaleLowerCase()
                                        .replace(/\s/g, "-") ===
                                      location.pathname
                                        .split("/")[1]
                                        .toLocaleLowerCase()
                                        .replace(/\s/g, "-")
                                        ? "active-menu"
                                        : ""
                                    }`}
                                  >
                                    {menuData ? (
                                      item?.dynamicText ? (
                                        item?.dynamicText
                                      ) : (
                                        item.text
                                      )
                                    ) : (
                                      <Skeleton width={100}></Skeleton>
                                    )}
                                  </h6>
                                </MuiMenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      ) : (
                        link.isPermanent && ( // Only render non-dropdown links if isPermanent is true
                          <div key={index}>
                            <Link
                              style={{
                                minWidth: "fit-content",
                                textDecoration: "none",
                                color: "#FFF",
                              }}
                              to={link?.link}
                            >
                              {link.dynamicText ? link.dynamicText : link.text}
                            </Link>
                          </div>
                        )
                      ),
                    )}
                </>
              )}
            </div>
          </Grid2>

          <Grid2 size={{ xs: 2, xl: 2, sm: 2, lg: 1, md: 2 }}>
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={openMenu ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openMenu ? "true" : undefined}
            >
              <Avatar
                src="/broken-image.jpg"
                style={{ width: 30, height: 30 }}
              />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={openMenu}
              onClose={handleClose}
              onClick={handleClose}
              slotProps={{
                paper: {
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&::before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              {load ? (
                <div
                  style={{
                    width: "300px",
                    textAlign: "center",
                    padding: "10px",
                    margin: "auto",
                  }}
                >
                  <BeatLoader color="#3661eb" />
                </div>
              ) : (
                <div>
                  <MenuItem
                    onClick={handleClose}
                    sx={{ textAlign: "center", margin: "auto" }}
                  >
                    <div style={{ textAlign: "center", margin: "auto" }}>
                      {menuData?.currentUser?.email}
                      {menuData?.currentUser?.lastName != ""
                        ? `${"("}${menuData?.currentUser?.lastName}${")"}`
                        : null}
                      {role == "NonAdmin" && (
                        <div>
                          <strong style={{ fontSize: "12px" }}>
                            Roles Associated
                          </strong>
                          <div
                            style={{
                              width: "400px",
                              textWrap: "wrap",
                            }}
                          >
                            {menuData?.connectedRoles?.map((item, index) => (
                              <span key={index}>
                                <span
                                  style={{
                                    fontSize: "13px",
                                  }}
                                >
                                  {item?.description}
                                </span>
                                {index !== menuData.connectedRoles.length - 1 &&
                                  ", "}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </MenuItem>
                  <Divider />
                  <MenuItem onClick={handleClose}>
                    <Grid2 container>
                      <Grid2 size={{ lg: 1, md: 1 }}>
                        <Avatar
                          style={{
                            height: "40px",
                            width: "40px",
                            marginRight: " 130px",
                          }}
                        />
                      </Grid2>
                      <Grid2
                        container
                        size={{ lg: 11, md: 11 }}
                        direction="column"
                        // alignItems="flex-end"
                        textAlign="center"
                      >
                        <div style={{ fontWeight: "bold" }}>StudyPortal</div>
                        <div style={{ fontSize: "0.8rem", color: "gray" }}>
                          Version 3.3.0.0-DESKTOP-CVB3602
                        </div>
                      </Grid2>
                    </Grid2>
                  </MenuItem>

                  <Divider />
                  <MenuItem>
                    <Grid2 container spacing={1}>
                      <Grid2 size={{ lg: 4, md: 4, sm: 4, xs: 4 }}>
                        <button className="create-btn-small">
                          Privacy Policy
                        </button>
                      </Grid2>
                      <Grid2 size={{ lg: 4, md: 4, sm: 4, xs: 4 }}>
                        <button
                          className="create-btn-small"
                          onClick={handleModalOpen}
                        >
                          Change Password
                        </button>
                      </Grid2>
                      <Grid2 size={{ lg: 4, md: 4, sm: 4, xs: 4 }}>
                        <button
                          className="create-btn-small"
                          onClick={handleLogout}
                        >
                          Logout
                        </button>
                      </Grid2>
                    </Grid2>
                  </MenuItem>
                </div>
              )}
            </Menu>
          </Grid2>
        </Grid2>
      </AppBar>
      <Modal
        open={openModal}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {/* <h4>Change Password</h4> */}
        <Box
          sx={style}
          component="form"
          onSubmit={handleSubmit(updatePassword)}
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Change Password
          </Typography>

          <div>
            <p className="labelStyles">
              Current Password<span>*</span>
            </p>
            <TextField
              size="small"
              fullWidth
              type={showCurrPassword ? "text" : "password"}
              {...register("currPassword")}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => toggleVisibility("curr")}
                      edge="end"
                    >
                      {showCurrPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            {errors.currPassword && (
              <div className="error-container">
                {errors.currPassword.message}
              </div>
            )}
          </div>

          <div>
            <p className="labelStyles">
              New Password<span>*</span>
            </p>
            <TextField
              size="small"
              fullWidth
              type={showNewPassword ? "text" : "password"}
              {...register("newPassword")}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => toggleVisibility("new")}
                      edge="end"
                    >
                      {showNewPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            {errors.newPassword && (
              <div className="error-container">
                {errors.newPassword.message}
              </div>
            )}
          </div>

          <div>
            <p className="labelStyles">
              Confirm Password<span>*</span>
            </p>
            <TextField
              size="small"
              fullWidth
              type={showConfirmPassword ? "text" : "password"}
              {...register("confirmPassword")}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => toggleVisibility("confirm")}
                      edge="end"
                    >
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            {errors.confirmPassword && (
              <div className="error-container">
                {errors.confirmPassword.message}
              </div>
            )}
            {values.newPassword !== values.confirmPassword && isDirty && (
              <div className="error-container">Passwords do not match</div>
            )}
          </div>
          <Grid2
            alignItems={"end"}
            justifyContent="end"
            container
            gap={1}
            sx={{ marginTop: "14%" }}
          >
            <Grid2 item md={6}>
              <button
                type="button"
                className="create-btn-outlined"
                onClick={(e) => {
                  e.preventDefault();
                  handleModalClose();
                  reset();
                }}
              >
                Cancel
              </button>
            </Grid2>
            <Grid2 item md={6}>
              <button
                type="submit"
                disabled={isChangePasswordDisabled(values)}
                className={
                  isChangePasswordDisabled(values)
                    ? "disabled-btn"
                    : "create-btn"
                }
              >
                Change Password
              </button>
            </Grid2>
          </Grid2>
        </Box>
      </Modal>
    </Box>
  );
};

export default Navbar;
